import React from 'react';
import ButtonClosedCardContent from './../ButtonClosedCardContent';
import ButtonRepoAndEnterCardContent from './../ButtonRepoAndEnterCardContent';
import TitleProject from './../TitleProject';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import "./ProjectCardContent.css";

const ProjectCardContent = ({ title, urlPage, urlGit, onHandleClasses }) => {
    return(
      <CardContent className="card-content position-absolute">
        <Grid item container spacing={2}>
          <ButtonClosedCardContent onHandleClasses={onHandleClasses} />
          <TitleProject title={title} /> 
          <ButtonRepoAndEnterCardContent urlPage={urlPage} urlGit={urlGit} />
        </Grid>
      </CardContent> 
    );
}

export default ProjectCardContent;